import colorVars from "@/assets/styles/colorVars"
import ArrowRightSrc from "@/assets/svg/ui/arrow-right.svg"
import React, { FC } from "react"
import { up } from "styled-breakpoints"
import styled from "styled-components"

import { TextButton } from "../button"

export interface IBanner {
  bannerUrl?: Queries.WpAcfLink
  text?: string
}

export interface BannerProps {
  data?: IBanner
}

const Wrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 8px 0;
  max-width: 820px;
  padding: 10px 32px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.14px;
  background: #f5f5f5;
  background: linear-gradient(
    271deg,
    rgba(52, 45, 94, 0.2) 22.2%,
    rgba(124, 107, 224, 0.2) 34.99%,
    rgba(203, 196, 243, 0.2) 52.37%
  );
  border-radius: 8px;

  ${up("md")} {
    flex-flow: row nowrap;
    gap: 0 32px;
    align-items: center;
  }
`
const BannerText = styled.span`
  padding: 2px 0;
  color: ${colorVars.violet.p6};
`
const BannerLink = styled(TextButton)`
  display: flex;
  flex: 1 0 auto;
  gap: 0 8px;
  align-items: center;
  padding: 2px 6px;
  margin: 0 0 0 -6px;
  font-size: 14px;
  font-weight: 600;
  color: white;
  transition: opacity 250ms ease;

  &::after {
    display: block;
    width: 11px;
    height: 11px;
    content: "";
    background: url("${ArrowRightSrc}") no-repeat center center;
    background-size: 11px 11px;
  }

  ${up("md")} {
    margin: auto 0;
  }
`

export const Banner: FC<BannerProps> = ({ data }) => {
  if (!data) return null

  const { bannerUrl, text } = data

  return (
    <Wrapper>
      {text && <BannerText>{text}</BannerText>}
      {bannerUrl && (
        <BannerLink link={bannerUrl} type="url">
          {bannerUrl.title}
        </BannerLink>
      )}
    </Wrapper>
  )
}
